import Config from './config';
import tools from './tools';
import vjsSrv from './vjsSrv';
import eventsSrv from './events';
import { PLAYER_METHODS } from 'vimmi-web-utils/cjs/postMessage';
import { PMWrap } from 'src/js/services/PMWrap';

export class AppRestriction {
  constructor() {
    this.currntModal = null;
    this.currentAsset = null;
    this.isChangedControls = false;
    this.options = {};
  }

  isRestricted(asset) {
    return asset && !!asset.restricted && !asset.preview;
  }

  skipPlay() {
    if (Config.get('eventsState.isCallPlay')) {
      vjsSrv.vjsPlayer.pause();
    }
  }


  reset() {
    if (this.currntModal) {
      this.currntModal.close();
      delete this.currntModal;
      this.currentAsset = null;
    }
  }


  hide() {
    if (Config.get('params.restrictions') === false) {
      return;
    }
    if (this.currntModal) {
      this.currntModal.close();
      delete this.currntModal;
    }
    if (this.isChangedControls) {
      if (vjsSrv.vjsPlayer.WrapperBigPlayBtn) {
        vjsSrv.vjsPlayer.WrapperBigPlayBtn.show();
      }
      if (Config.get('params.controls')) {
        vjsSrv.controls(true);
      }
      this.isChangedControls = false;
    }
    vjsSrv.vjsPlayer.removeClass('restricted-content');
    this.currentAsset = null;
  }

  show(asset) {
    if (Config.get('params.restrictions') === false) {
      return;
    }
    this.hide();
    this.currentAsset = asset;
    this.skipPlay();
    if (Config.get('params.controls')) {
      vjsSrv.controls(false);
    }
    if (vjsSrv.vjsPlayer.WrapperBigPlayBtn) {
      vjsSrv.vjsPlayer.WrapperBigPlayBtn.hide();
    }
    this.isChangedControls = true;
    vjsSrv.vjsPlayer.addClass('restricted-content');
    this.currntModal = vjsSrv.vjsPlayer.createModal('', { uncloseable: true });
    let text = '';
    let customHtmlEl = null;
    let customHtmlElPos = 'before';
    switch (this.currentAsset.restricted.toLowerCase()) {
      case 'concurrency'.toLowerCase() :
        text = 'Sorry, your account is exceeding maximum concurrency streaming limit. Please stop playing contents on some device and this device can be enabled';
        break;
      case 'restrictedForAge'.toLowerCase() :
        text = 'This content is restricted by age.';
        break;
      case 'RestrictedForCountry'.toLowerCase() :
        text = 'This content is restricted for your country.';
        break;
      case 'RestrictedForDevice'.toLowerCase() :
        text = 'This content is restricted for your device.';
        break;
      case 'RestrictedForNotFreeInSyncMode'.toLowerCase() :
        text = 'The application is updating information. You can watch premium content when the update has been completed.';

        this.currntModal.addClass('modal-with-buttons');
        break;
      case 'RestrictedForNotFree'.toLowerCase() :
        if ((Config.get(`params.portal.customer`) || '').toLowerCase() === 'ais') {
          if (this.currentAsset.isLive) {
            text = 'This channel is not available in your package. You can subscribe the packages at ais.co.th or my AIS.';
          } else {
            text = 'This video content is not available in your package. You can subscribe the packages at ais.co.th or my AIS.';
          }
        } else {
          if (this.currentAsset.isLive) {
            text = 'This channel is not available in your package.';
          } else {
            text = 'This video content is not available in your package.';
          }
        }

        this.currntModal.addClass('modal-with-buttons');
        break;
      case 'RestrictedForUnknow'.toLowerCase() :
        customHtmlEl = tools.htmlToElement(`
                    <button class="vjs-big-play-button" type="button" title="Play Video" >
                        <span aria-hidden="true" class="vjs-icon-placeholder"></span>
                        <span class="vjs-control-text" aria-live="polite">Play Video</span>
                    </button>
                `);
        customHtmlEl.onclick = (event) => {
          eventsSrv.emit(PLAYER_METHODS.FORCE_LOGIN);

          if (!Config.get('params.imported')) {
            PMWrap.inst().sendWrappedEvent(PLAYER_METHODS.FORCE_LOGIN);
          }
          event.stopImmediatePropagation();
          event.preventDefault();
        };
        if ((Config.get(`params.portal.customer`) || '').toLowerCase() === 'ais') {
          text = 'Please Login';
        }
        break;
      case 'RestrictedForLive'.toLowerCase() :
      default:
        text = 'This content is restricted for unauthorized users. Please Login or register.';
        break;
    }

    vjsSrv.vjsPlayer.el().dataset.restriction = this.currentAsset.restricted;
    this.currntModal.contentEl_.innerHTML = `<span class="modal-text">${vjsSrv.vjsPlayer.localize(text)}</span>`;

    if (customHtmlEl) {
      let node = this.currntModal.contentEl_;
      node[customHtmlElPos === 'after' ? 'appendChild' : 'insertBefore'](customHtmlEl, node.childNodes[0]);
    }

    this.currntModal.addClass('vjs-restriction-modal');
  }

}

const Restriction = new AppRestriction();

export default Restriction;